module.exports = __webpack_public_path__ + "f3189365642202ae45aa9e5d1b945b13.png";